export const personalInfo = {
  name: "Dr. Oktay BAHADIR",
  title: "Human Rights Expert",
  email: "oktaybahadir51@gmail.com",
  twitter: "https://twitter.com/Bahadir_Dr",
  youtube: "https://www.youtube.com/@dr.oktaybahadir",
  blog: "https://oktaybahadir.blogspot.com",
  profileImage: "/assets/images/profile.png",
  cvLink: "/assets/pdfs/BAHADIR_Oktay_CV_in_English_short.docx"
};

export const aboutMe = {
  shortBio: "Oktay Bahadır is an independent human rights expert providing litigation consultancy services for the applicants seeking redress before the Turkish Constitutional Court and the European Court of Human Rights, as well as various UN treaty bodies. He has a proven academic and practical expertise in international human rights law as well as criminal law.",
  fullBio: [
    "Oktay Bahadır is an independent human rights expert providing litigation consultancy services for the applicants seeking redress before the Turkish Constitutional Court and the European Court of Human Rights, as well as various UN treaty bodies. He has a proven academic and practical expertise in international human rights law as well as criminal law.",
    "Apart from his independent career, he has over 10 years' professional experience covering the Turkish judicial service and justice administration, as well as his international assignment for a two-month period at the European Court of Human Rights.",
    "From 2006 to 2016, he worked as a prosecutor in various provinces and districts. For more than three-year-period, between 2011 and 2014, he was employed at the Turkish Ministry of Justice as a rapporteur judge dealing mainly with preparation of Government observations submitted to the Turkish Constitutional Court and the European Court of Human Rights. Along with his professional works at the Ministry of Justice, he lectured classes of human rights at the Turkish Justice Academy for nearly two years.",
    "He holds a master's degree on public law obtained from Gazi University in Ankara. He received his doctorate on human rights law in 2014. He studied English in the United States for one year. He has published numerous articles in various periodicals and on the Internet and published a book named 'The Right to Life'.",
    "Oktay Bahadır, who is married and has three children, is fluent in English and French."
  ]
};

export const workExperience = [
  {
    period: "2015 - 2016",
    position: "Prosecutor",
    organization: "Prosecutor's Office of Bafra, Turkey",
    description: ""
  },
  {
    period: "2011 - 2015",
    position: "Rapporteur Judge",
    organization: "The Ministry of Justice, Human Rights Department, Turkey",
    description: ""
  },
  {
    period: "2013",
    position: "Trainee Judge",
    organization: "The European Court of Human Rights, Strasbourg, France",
    description: ""
  },
  {
    period: "2012 - 2013",
    position: "Lecturer",
    organization: "The Justice Academy of Turkey",
    description: ""
  },
  {
    period: "2008 - 2011",
    position: "Prosecutor",
    organization: "Prosecutor's Office of Kocaali, Turkey",
    description: ""
  },
  {
    period: "2006 - 2008",
    position: "Prosecutor",
    organization: "Prosecutor's Office of Van, Turkey",
    description: ""
  },
  {
    period: "2005 - 2006",
    position: "Trainee Judge",
    organization: "The Ministry of Justice, Turkey",
    description: ""
  }
];

export const diplomas = [
  {
    period: "2009 - 2014",
    degree: "PhD",
    title: "The Right to Life in the Light of the Case-law of the European Court of Human Rights and Turkey",
    institution: "Gazi University, Ankara"
  },
  {
    period: "2005 - 2009",
    degree: "Master's Degree",
    title: "The Right to Life in The European Human Rights and The Turkish Constitutional Law",
    institution: "Gazi University, Ankara"
  },
  {
    period: "1998 - 2003",
    degree: "Bachelor's Degree",
    title: "Law",
    institution: "Law Faculty"
  }
];

export const certificates = [
  {
    year: "2022",
    issuer: "Coursera",
    title: "Completion of Introduction to Cybersecurity Tools & Cyber Attacks"
  },
  {
    year: "2014",
    issuer: "Council of Europe, Steering Committee for Human Rights (CDDH)",
    title: "Discussion on the finalization of the draft compilation of existing Council of Europe standards relating to the principles of freedom of thought, conscience and religion and the links to other rights under European Convention on Human Rights (ECHR)"
  },
  {
    year: "2013",
    issuer: "The Justice Academy of Turkey",
    title: "Improving Competence of Lecturers"
  },
  {
    year: "2012",
    issuer: "The United Nations High Commissioner for Human Rights (OHCHR), Human Rights Committee",
    title: "First periodic review of the Republic of Turkey's compliance with the International Covenant on Civil and Political Rights (ICCPR)"
  },
  {
    year: "2013",
    issuer: "Raoul Wallenberg Institute of Human Rights and Humanitarian Law",
    title: "Establishing a team of qualified master trainers in the human rights field"
  },
  {
    year: "2012",
    issuer: "The Justice Academy of Turkey",
    title: "International Symposium on 'Combating Violence against Women in the Context of Effective Implementation of Human Rights Standards'"
  },
  {
    year: "2012",
    issuer: "The Justice Academy of Turkey",
    title: "Improving Competence of Lecturers"
  },
  {
    year: "2011",
    issuer: "The Ministry of Justice",
    title: "High Level Conference and a Workshop on the 'Case-law of the European Court of Human Rights concerning Turkey, Difficulties and Suggestions for Solutions'"
  },
  {
    year: "2011",
    issuer: "The High Council of Judges and Prosecutors",
    title: "Determining the problems of the judicial organisation and draw a roadmap accordingly"
  }
];

export const publicationsData = {
  en: [
  {
    title: "Osmanlı Devlet Geleneğinde Adaletnameler ('Adaletname's in the Context of the Ottoman Empire's Tradition)",
    journal: "Adalet Review",
    date: "January 2010",
    summary: "In this study, the importance of 'Adaletname' in the Ottoman State tradition has been examined. In this context, the concept of 'Adaletname', their source (origin) and their characteristics are emphasized. A comparison was made between the 'Adaletname' issued in the classical period and the 'Adaletname' issued in the modern period.",
    pdfLink: "/assets/pdfs/adaletnameler.pdf",
    isPdf: true
  },
  {
    title: "Ombudsmanlık Kurumunun İsveç, İngiltere ve Fransa ile Karşılaştırmalı İncelenmesi (A Comparative Study on Ombudsman with Sweden, the UK and France)",
    journal: "Türkiye Adalet Akademisi Review",
    date: "April 2010",
    summary: "Ombudsman, is an institution that studies the complaints coming from the public, which is related to procedures and deeds that the administration undertakes, and searches for solution ways. Its function has been not to leave the person alone against the administration and to defend his/her rights. Ombudsman is equipped with the authorities such as investigating and researching, criticizing, announcing the problematic sides of administration to the parliament and public opinion. This article contains Ombudsman corporation as an administrative control tool, its historical background, some examples of this corporation in the World and discussions about its applicability in Turkey.",
    pdfLink: "/assets/pdfs/ombudsmanlik.pdf",
    isPdf: true
  },
  {
    title: "İnsan Haklarının Uluslararası Yargısal Korunması: Uluslararası Ceza Mahkemeleri (International Judicial Protection of Human Rights: International Criminal Courts)",
    journal: "Terazi Law Review",
    date: "June 2010",
    summary: "As a result of the painful experiences of humanity, the importance of the human rights in the international arena has developed greatly and this concept has been the subject of many international documents. However, over time, this was not seen sufficient and the need for the protection of human rights in the international arena has emerged. In order to meet this need, the International Criminal Courts of Nuremberg, Tokyo, the former Yugoslavia and Rwanda, which are extraordinary and temporary courts, and finally the International Criminal Court with the Rome Statute were established. The aim of this study is to examine the international criminal courts established for the purpose of prosecuting individuals in the international community for their international human rights violations.",
    pdfLink: "https://www.seckin.com.tr/kitap/397562828",
    isExternal: true
  },
  {
    title: "Avrupa İnsan Hakları Mahkemesi'nin Yaşama Hakkına İlişkin Finogenov ve Diğerleri / Rusya Kararı Özet Çevirisi (Summary Translation of the European Court of Human Rights' Finogenov and Others / Russia Judgement Concerning the Right to Life)",
    journal: "Küresel Bakış-Translation Law Journal",
    date: "October 2012",
    summary: "This case concerned the siege of the Dubrovka theater in Moscow on 23 October 2002 by more than 40 Chechens and the use of gas to rescue the hostages in the operation. More than 900 people were held at gunpoint in the theater for three days. Chechens demanded the withdrawal of Russian troops from Chechen lands. On October 26, at around 5-5.30 am, drug gas was injected into the theater by the Russian security forces through the ventilation system. Later, a special team entered the building. All Chechens were killed, as well as 125 hostages died either on the spot or in hospitals.",
    pdfLink: "/assets/pdfs/finogenov.pdf",
    isPdf: true
  },
  {
    title: "Zor Kullanma Yetkisine İlişkin Sınırın Aşılması Suçu (Offence of Exceeding of Authorisation for Use of Force)",
    journal: "Türkiye Adalet Akademisi Review",
    date: "October 2012",
    summary: "In this article, particularly notion of use of force and its conditions are examined. Then, elements of the offence of 'Exceeding the Limits of Authorisation for Use of Force' regulated under article 256 of the Turkish Criminal Code are discussed together with different views in the doctrine and judgments of the Court of Cassation. Furthermore, when appropriate, case law of the European Court of Human Rights with regard to the matter is also mentioned.",
    pdfLink: "/assets/pdfs/zor-kullanma.pdf",
    isPdf: true
  },
  {
    title: "Authority for the Use of Force and Its Limitations within the Scope of Article 2 of the European Convention on Human Rights (Peer-reviewed Article in English)",
    journal: "Human Rights Review",
    date: "December 2012",
    summary: "The main objective of this article is to reflect the viewpoint of the Court in regard to the use of force which could be considered as being in breach of the right to life. For that reason, the law-enforcement officers' authority to use force and its limitations will be assessed pursuant to Article 2 of the Convention. Moreover, the judgments especially relating to Article 3 will be referred when appropriate.",
    pdfLink: "/assets/pdfs/use-of-force.pdf",
    isPdf: true
  },
  {
    title: "Özel Güvenlik Görevlilerinin Zor Kullanma Yetkisi (Authorisation for Use of Force of Private Security Forces)",
    journal: "Uyuşmazlık Mahkemesi Review",
    date: "June 2014",
    summary: "The authorities of the private security forces and the limitations of these authorities are primarily discussed in this article. The authority for use of force of the private security forces is subsequently examined. Moreover, the offences committed both against and by the private security officers while exercising their authority for use of force are addressed in this article.",
    pdfLink: "/assets/pdfs/ozel-guvenlik.pdf",
    isPdf: true
  },
  {
    title: "Yaşama Hakkı (The Right to Life) - Book",
    journal: "Seçkin Publisher",
    date: "May 2015",
    summary: "This book, which examines the right to life, which has a prominent place among human rights, in the light of the decisions of the European Court of Human Rights (ECHR), consists of three parts: In the first part, the concept of the right to life and its limits are discussed. In the second part, the obligations of the state are included within the framework of article 2 of the European Convention on Human Rights, which regulates the right to life. In the third part, in general, parallel titles were used with the second part. The jurisprudence of the ECtHR regarding the right to life has been evaluated more specifically for Turkey.",
    pdfLink: "https://www.seckin.com.tr/kitap/676644622",
    isExternal: true
  },
  {
    title: "Haksız Tutukluluk Başvurularında Hükümet Görüşlerine Karşı Cevap Dilekçesi Formatı",
    journal: "Legal Document",
    date: "July 2022",
    summary: "This document has been prepared as an opinion petition format against government views for unlawful detention applications. In particular, the parts highlighted in yellow need to be personalized and some parts should be deleted according to the complaints communicated on the application basis.",
    pdfLink: "/assets/pdfs/haksiz-tutukluluk.docx",
    isDocx: true
  }
  ],
  tr: [
    {
      title: "Osmanlı Devlet Geleneğinde Adaletnameler",
      journal: "Adalet Dergisi",
      date: "Ocak 2010",
      summary: "Bu çalışmada Osmanlı Devlet geleneğinde 'Adaletname'lerin önemi incelenmiştir. Bu bağlamda 'Adaletname' kavramı, kaynakları ve özellikleri üzerinde durulmuştur. Klasik dönemde çıkarılan 'Adaletname'ler ile modern dönemde çıkarılan 'Adaletname'ler arasında karşılaştırma yapılmıştır.",
      pdfLink: "/assets/pdfs/adaletnameler.pdf",
      isPdf: true
    },
    {
      title: "Ombudsmanlık Kurumunun İsveç, İngiltere ve Fransa ile Karşılaştırmalı İncelenmesi",
      journal: "Türkiye Adalet Akademisi Dergisi",
      date: "Nisan 2010",
      summary: "Ombudsman, idarenin gerçekleştirdiği usul ve işlemlerle ilgili halktan gelen şikayetleri inceleyen ve çözüm yolları arayan bir kurumdur. İşlevi, kişiyi idare karşısında yalnız bırakmamak ve haklarını savunmaktır. Ombudsman, soruşturma ve araştırma, eleştirme, idarenin sorunlu yönlerini parlamentoya ve kamuoyuna duyurma gibi yetkilerle donatılmıştır. Bu makale, bir idari kontrol aracı olarak Ombudsman kurumunu, tarihsel geçmişini, Dünya'dan bazı örneklerini ve Türkiye'de uygulanabilirliğine ilişkin tartışmaları içermektedir.",
      pdfLink: "/assets/pdfs/ombudsmanlik.pdf",
      isPdf: true
    },
    {
      title: "İnsan Haklarının Uluslararası Yargısal Korunması: Uluslararası Ceza Mahkemeleri",
      journal: "Terazi Hukuk Dergisi",
      date: "Haziran 2010",
      summary: "İnsanlığın acı deneyimleri sonucunda, uluslararası alanda insan haklarının önemi büyük ölçüde gelişmiş ve bu kavram birçok uluslararası belgenin konusu olmuştur. Ancak zamanla bu yeterli görülmemiş ve insan haklarının uluslararası alanda korunması ihtiyacı ortaya çıkmıştır. Bu ihtiyacı karşılamak için olağanüstü ve geçici mahkemeler olan Nürnberg, Tokyo, eski Yugoslavya ve Ruanda Uluslararası Ceza Mahkemeleri ve son olarak Roma Statüsü ile Uluslararası Ceza Mahkemesi kurulmuştur. Bu çalışmanın amacı, uluslararası toplumda bireylerin uluslararası insan hakları ihlalleri nedeniyle yargılanması amacıyla kurulan uluslararası ceza mahkemelerini incelemektir.",
      pdfLink: "https://www.seckin.com.tr/kitap/397562828",
      isExternal: true
    },
    {
      title: "Avrupa İnsan Hakları Mahkemesi'nin Yaşama Hakkına İlişkin Finogenov ve Diğerleri / Rusya Kararı Özet Çevirisi",
      journal: "Küresel Bakış - Çeviri Hukuk Dergisi",
      date: "Ekim 2012",
      summary: "Bu dava, 23 Ekim 2002'de Moskova'daki Dubrovka tiyatrosunun 40'tan fazla Çeçen tarafından kuşatılması ve rehineleri kurtarmak için gaz kullanılması operasyonunu konu almaktadır. 900'den fazla kişi üç gün boyunca tiyatroda silah zoruyla tutuldu. Çeçenler, Rus birliklerinin Çeçen topraklarından çekilmesini talep etti. 26 Ekim sabahı saat 5-5.30 civarında, Rus güvenlik güçleri tarafından havalandırma sistemi aracılığıyla tiyatroya uyuşturucu gazı enjekte edildi. Daha sonra özel bir tim binaya girdi. Tüm Çeçenler öldürüldü ve 125 rehine de ya olay yerinde ya da hastanelerde hayatını kaybetti.",
      pdfLink: "/assets/pdfs/finogenov.pdf",
      isPdf: true
    },
    {
      title: "Zor Kullanma Yetkisine İlişkin Sınırın Aşılması Suçu",
      journal: "Türkiye Adalet Akademisi Dergisi",
      date: "Ekim 2012",
      summary: "Bu makalede özellikle zor kullanma kavramı ve koşulları incelenmiştir. Ardından Türk Ceza Kanunu'nun 256. maddesinde düzenlenen 'Zor Kullanma Yetkisinin Sınırının Aşılması' suçunun unsurları, doktrindeki farklı görüşler ve Yargıtay kararları ile birlikte tartışılmıştır. Ayrıca uygun durumlarda Avrupa İnsan Hakları Mahkemesi'nin konuya ilişkin içtihatlarına da atıfta bulunulmuştur.",
      pdfLink: "/assets/pdfs/zor-kullanma.pdf",
      isPdf: true
    },
    {
      title: "Avrupa İnsan Hakları Sözleşmesi'nin 2. Maddesi Kapsamında Zor Kullanma Yetkisi ve Sınırlamaları (Hakemli İngilizce Makale)",
      journal: "İnsan Hakları Dergisi",
      date: "Aralık 2012",
      summary: "Bu makalenin temel amacı, yaşam hakkının ihlali olarak değerlendirilebilecek zor kullanımına ilişkin Mahkeme'nin bakış açısını yansıtmaktır. Bu nedenle, kolluk görevlilerinin zor kullanma yetkisi ve sınırlamaları Sözleşme'nin 2. Maddesi uyarınca değerlendirilecektir. Ayrıca, uygun durumlarda özellikle 3. Madde ile ilgili kararlara da atıfta bulunulacaktır.",
      pdfLink: "/assets/pdfs/use-of-force.pdf",
      isPdf: true
    },
    {
      title: "Özel Güvenlik Görevlilerinin Zor Kullanma Yetkisi",
      journal: "Uyuşmazlık Mahkemesi Dergisi",
      date: "Haziran 2014",
      summary: "Bu makalede öncelikle özel güvenlik görevlilerinin yetkileri ve bu yetkilerin sınırları tartışılmaktadır. Ardından özel güvenlik görevlilerinin zor kullanma yetkisi incelenmektedir. Ayrıca, özel güvenlik görevlilerinin zor kullanma yetkilerini kullanırken hem kendilerine karşı hem de kendileri tarafından işlenen suçlar bu makalede ele alınmaktadır.",
      pdfLink: "/assets/pdfs/ozel-guvenlik.pdf",
      isPdf: true
    },
    {
      title: "Yaşama Hakkı - Kitap",
      journal: "Seçkin Yayıncılık",
      date: "Mayıs 2015",
      summary: "İnsan hakları arasında önemli bir yere sahip olan yaşama hakkını Avrupa İnsan Hakları Mahkemesi (AİHM) kararları ışığında inceleyen bu kitap üç bölümden oluşmaktadır: Birinci bölümde yaşama hakkı kavramı ve sınırları ele alınmıştır. İkinci bölümde yaşama hakkını düzenleyen Avrupa İnsan Hakları Sözleşmesi'nin 2. maddesi çerçevesinde devletin yükümlülükleri yer almaktadır. Üçüncü bölümde ise genel olarak ikinci bölümle paralel başlıklar kullanılmış, AİHM'in yaşama hakkına ilişkin içtihatları Türkiye özelinde daha spesifik olarak değerlendirilmiştir.",
      pdfLink: "https://www.seckin.com.tr/kitap/676644622",
      isExternal: true
    },
    {
      title: "Haksız Tutukluluk Başvurularında Hükümet Görüşlerine Karşı Cevap Dilekçesi Formatı",
      journal: "Hukuki Belge",
      date: "Temmuz 2022",
      summary: "Bu belge, haksız tutukluluk başvuruları için hükümet görüşlerine karşı görüş dilekçesi formatı olarak hazırlanmıştır. Özellikle sarıya boyalı kısımların kişiselleştirilmesi ve başvuru özelinde komünike edilen şikayetlere göre bazı kısımların silinmesi gerekir.",
      pdfLink: "/assets/pdfs/haksiz-tutukluluk.docx",
      isDocx: true
    }
  ],
  fr: [
    {
      title: "Osmanlı Devlet Geleneğinde Adaletnameler (Les 'Adaletname' dans la tradition de l'Empire Ottoman)",
      journal: "Adalet Review",
      date: "Janvier 2010",
      summary: "Cette étude examine l'importance des 'Adaletname' dans la tradition de l'État ottoman. Dans ce contexte, le concept d''Adaletname', leur source (origine) et leurs caractéristiques sont mis en évidence. Une comparaison a été faite entre les 'Adaletname' émis à l'époque classique et ceux émis à l'époque moderne.",
      pdfLink: "/assets/pdfs/adaletnameler.pdf",
      isPdf: true
    },
    {
      title: "Ombudsmanlık Kurumunun İsveç, İngiltere ve Fransa ile Karşılaştırmalı İncelenmesi (Étude comparative sur l'Ombudsman avec la Suède, le Royaume-Uni et la France)",
      journal: "Türkiye Adalet Akademisi Review",
      date: "Avril 2010",
      summary: "L'Ombudsman est une institution qui étudie les plaintes du public concernant les procédures et actes de l'administration et recherche des solutions. Sa fonction est de ne pas laisser la personne seule face à l'administration et de défendre ses droits.",
      pdfLink: "/assets/pdfs/ombudsmanlik.pdf",
      isPdf: true
    },
    {
      title: "İnsan Haklarının Uluslararası Yargısal Korunması: Uluslararası Ceza Mahkemeleri (Protection judiciaire internationale des droits de l'homme : Cours pénales internationales)",
      journal: "Terazi Law Review",
      date: "Juin 2010",
      summary: "Suite aux expériences douloureuses de l'humanité, l'importance des droits de l'homme sur la scène internationale s'est considérablement développée. Cette étude examine les cours pénales internationales établies pour poursuivre les individus pour leurs violations des droits de l'homme.",
      pdfLink: "https://www.seckin.com.tr/kitap/397562828",
      isExternal: true
    },
    {
      title: "Yaşama Hakkı (Le droit à la vie) - Livre",
      journal: "Seçkin Publisher",
      date: "Mai 2015",
      summary: "Ce livre, qui examine le droit à la vie à la lumière des décisions de la Cour européenne des droits de l'homme, se compose de trois parties : la première partie traite du concept du droit à la vie et de ses limites, la deuxième partie des obligations de l'État, et la troisième partie évalue la jurisprudence de la CEDH spécifiquement pour la Turquie.",
      pdfLink: "https://www.seckin.com.tr/kitap/676644622",
      isExternal: true
    },
    {
      title: "Haksız Tutukluluk Başvurularında Hükümet Görüşlerine Karşı Cevap Dilekçesi Formatı",
      journal: "Document juridique",
      date: "Juillet 2022",
      summary: "Ce document a été préparé comme format de pétition d'opinion contre les opinions du gouvernement pour les demandes de détention illégale.",
      pdfLink: "/assets/pdfs/haksiz-tutukluluk.docx",
      isDocx: true
    }
  ],
  de: [
    {
      title: "Osmanlı Devlet Geleneğinde Adaletnameler ('Adaletname' in der Tradition des Osmanischen Reiches)",
      journal: "Adalet Review",
      date: "Januar 2010",
      summary: "In dieser Studie wird die Bedeutung der 'Adaletname' in der osmanischen Staatstradition untersucht. In diesem Zusammenhang werden das Konzept der 'Adaletname', ihre Quelle (Ursprung) und ihre Eigenschaften hervorgehoben.",
      pdfLink: "/assets/pdfs/adaletnameler.pdf",
      isPdf: true
    },
    {
      title: "Ombudsmanlık Kurumunun İsveç, İngiltere ve Fransa ile Karşılaştırmalı İncelenmesi (Vergleichende Studie zum Ombudsman mit Schweden, Großbritannien und Frankreich)",
      journal: "Türkiye Adalet Akademisi Review",
      date: "April 2010",
      summary: "Der Ombudsman ist eine Institution, die Beschwerden der Öffentlichkeit über Verfahren und Handlungen der Verwaltung untersucht und nach Lösungen sucht. Seine Funktion besteht darin, die Person gegenüber der Verwaltung nicht allein zu lassen und ihre Rechte zu verteidigen.",
      pdfLink: "/assets/pdfs/ombudsmanlik.pdf",
      isPdf: true
    },
    {
      title: "İnsan Haklarının Uluslararası Yargısal Korunması: Uluslararası Ceza Mahkemeleri (Internationaler gerichtlicher Schutz der Menschenrechte: Internationale Strafgerichtshöfe)",
      journal: "Terazi Law Review",
      date: "Juni 2010",
      summary: "Als Ergebnis der schmerzhaften Erfahrungen der Menschheit hat sich die Bedeutung der Menschenrechte auf internationaler Ebene stark entwickelt. Diese Studie untersucht die internationalen Strafgerichtshöfe, die zur Verfolgung von Einzelpersonen wegen ihrer internationalen Menschenrechtsverletzungen eingerichtet wurden.",
      pdfLink: "https://www.seckin.com.tr/kitap/397562828",
      isExternal: true
    },
    {
      title: "Yaşama Hakkı (Das Recht auf Leben) - Buch",
      journal: "Seçkin Publisher",
      date: "Mai 2015",
      summary: "Dieses Buch, das das Recht auf Leben im Lichte der Entscheidungen des Europäischen Gerichtshofs für Menschenrechte untersucht, besteht aus drei Teilen: Im ersten Teil werden das Konzept des Rechts auf Leben und seine Grenzen erörtert, im zweiten Teil die Pflichten des Staates und im dritten Teil wird die Rechtsprechung des EGMR speziell für die Türkei bewertet.",
      pdfLink: "https://www.seckin.com.tr/kitap/676644622",
      isExternal: true
    },
    {
      title: "Haksız Tutukluluk Başvurularında Hükümet Görüşlerine Karşı Cevap Dilekçesi Formatı",
      journal: "Rechtsdokument",
      date: "Juli 2022",
      summary: "Dieses Dokument wurde als Meinungsformat gegen Regierungsansichten für unrechtmäßige Inhaftierungsanträge erstellt.",
      pdfLink: "/assets/pdfs/haksiz-tutukluluk.docx",
      isDocx: true
    }
  ]
};
